var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    id: 1130021148,
    className: "svg u_1130021148",
    "data-icon-custom": "true",
    "data-icon-name": "mail.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-1016016948{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#4396EE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-1016016948",
    d: "M70.47,59.46,87.71,73.25a4.69,4.69,0,0,0,.69-2.46V39.21a4.72,4.72,0,0,0-1-2.94L61.15,62.43a8.69,8.69,0,0,1-12.3,0L22.6,36.3a4.68,4.68,0,0,0-1,2.91V70.79a4.75,4.75,0,0,0,.74,2.55L39.53,59.46l1.92,2.38L24.8,75.29a4.79,4.79,0,0,0,1.57.27H83.63a4.78,4.78,0,0,0,1.69-.31L68.56,61.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-1016016948",
    d: "M55,61.92a5.61,5.61,0,0,0,4-1.65L84.74,34.58a4.56,4.56,0,0,0-1.11-.14H26.37a4.37,4.37,0,0,0-1.15.15L51,60.27A5.63,5.63,0,0,0,55,61.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.abd3e57ea6d07e895097206275b9d084.svg";
export { ForwardRef as ReactComponent };